// LIBRARY
import Swal from "sweetalert2"
import { format_date, loading } from "../../components/CustomComponent"
import ReactLoading from "react-loading"

import LOGO from "../../components/image/haladiem.png";
import PENDING from "../../components/image/pending.gif"
import PROCESS from "../../components/image/process.gif"
import SUCCESS from "../../components/image/success.gif"
import CANCEL from "../../components/image/cancel.gif"
import WHEELCHAIR from "../../components/image/wheelchair.gif"
import FIX from "../../components/image/fix.gif"
import CAR from "../../components/image/car-service.gif"
import EMERGENCY from "../../components/image/emergency.gif"
import TROLLEY from "../../components/image/trolley.gif"
import GOLFCART from "../../components/image/golf-cart.gif"
import STAR from "../../components/image/star.gif"
import STAR_ from "../../components/image/star.png"
import Cookies from "universal-cookie"
import React, { Component } from "react"

// CSS
import "../../components/css/style.css"
import "../../components/css/bootstrap.css"

const IMAGE_STATUS = {
  "รอตอบรับ": PENDING,
    "รับงานแล้ว": PROCESS,
    "สำเร็จ": SUCCESS,
    "ยกเลิก": CANCEL
}
export default class LoginScreen extends Component {
  constructor(props) {
    super(props)
    this.state = { 
      step: 1,
      uid: this.params("uid") || "",
      
      running_number: this.params("running_number") || "",
      project_name: this.params("project_name") || "",
      agency_name: this.params("agency_name") || "",
      service_start_at: this.params("service_start_at") || "",
      status: "สำเร็จ",
      
      remark: "",
      description: "",
      suggestion: "",
      star: null,

      loading: false,
      showSecond: false
    }
    this.interval = null;
    this.animate = null;
  }

  stopStatusPolling = () => {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  startStatusPolling = (uid) => {
    if (!uid || this.interval) return;
    this.interval = setInterval(() => {
      this.GET(uid);
    }, 10000);
  }

  syncStatusOnAppResume = () => {
    const uid = this.params("uid");
    if (!uid) return;
    this.GET(uid);
  }

  handleVisibilityChange = () => {
    if (!document.hidden) {
      this.syncStatusOnAppResume();
    }
  }

  async componentDidMount() {
    let uid = this.params("uid");
     let location_id = this.params("location_id");
    if(uid){
      this.setState({step: 2, loading: true});
      const currentStatus = await this.GET(uid);
      if (!["สำเร็จ", "ยกเลิก"].includes(currentStatus)) {
        this.startStatusPolling(uid);
      }
    }
    if(!location_id){
      this.alert("warning","แจ้งเตือน","ไม่พบสถานที่ที่ต้องการขอความช่วยเหลือ กรุณาลองใหม่อีกครั้ง","","/")
    }
    this.animate = setInterval(() => {
      this.setState({showSecond: !this.state.showSecond})
    }, 2000);
    window.addEventListener("pageshow", this.syncStatusOnAppResume);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }
  componentWillUnmount(){
    this.stopStatusPolling();
    if (this.animate) {
      clearInterval(this.animate);
    }
    window.removeEventListener("pageshow", this.syncStatusOnAppResume);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }
  GET(uid) {
    const requestOptions = {method: "GET", headers: {"Content-Type": "application/json", accept: "application/json"}}
    return fetch(global.api + "v1/call-service/transaction-public?uid="+ uid, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          const currentStatus = result.data.data.status;
          this.setState({ 
            running_number: result.data.data.running_number,
            project_name: result.data.data.project_name,
            agency_name: result.data.data.agency_name,
            service_start_at: result.data.data.service_start_at,
            status: currentStatus,
            description: result.data.data.description,
            loading: false
           })
           if(["สำเร็จ","ยกเลิก"].includes(currentStatus)){
            this.stopStatusPolling();
           }
           return currentStatus;
        } else {
          this.setState({loading: false})
         this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
         return null;
        }
      })
      .catch((e) => {
        this.setState({loading: false})
       this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
       return null;
      })
  }
  Create = async (service,service_en) => {
    let location_id = this.params("location_id");
    if(await this.alert("submit","ยืนยัน",`ยืนยันการเรียกใช้บริการ "${service}"`)){
      this.setState({loading: true})
    const requestOptions = {
      method: "POST",
      headers: {"Content-Type": "application/json", accept: "application/json"},
      body: JSON.stringify({
        cs_location_id: location_id,
        service_name: service,
        description: "",
        status: "รอตอบรับ",
      }),
    }
    fetch(global.api + "v1/call-service/transaction/create", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result)
        if (result.status) {
        this.setState({loading: false})
          this.alert("success", "ส่งคำขอสำเร็จ", "",`
            <h4 class="mb-2 fw-bold">Request Sent!</h4>
            <div class="text-secondary">Your Request ID:</div>
            <h4 class="fw-bold mb-3">${result.data?.data?.running_number.split("-")[1].slice(-4) || ""}</h4>
            <div class="d-flex justify-content-center mb-3">
              <div class="mx-1">โครงการ</div> <div class="text-secondary fw-bold">${result.data?.data?.project_name || ""}</div>
              <div class="mx-1">หน่วยงาน</div> <div class="text-secondary fw-bold">${result.data?.data?.agency_name || ""}</div>
            </div>
            <div class="text-secondary fw-bold">บริการ: ${service || ""}</div>
            `,
            `/service?uid=${encodeURIComponent(result.data?.data?.uid)}&location_id=${encodeURIComponent(location_id)}&running_number=${encodeURIComponent(result.data?.data?.running_number)}&project_name=${encodeURIComponent(result.data?.data?.project_name)}&agency_name=${encodeURIComponent(result.data?.data?.agency_name)}&service=${encodeURIComponent(service)}&service_en=${encodeURIComponent(service_en)}&service_start_at=${encodeURIComponent(result.data?.data?.service_start_at)}`)
    
        } else {
          this.setState({loading: false})
          this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
        }
      }).catch(() => this.setState({loading: false}))
    }
  }
  Update = (_status) => {
    const {uid, description, remark, status, star, suggestion} = this.state;
    this.setState({loading: true})
   const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({
        uid,
        description: description + (remark ? ("|user:"+ remark) : "") + (star ? ("|rate:"+ star) : "") + (suggestion ? ("|suggestion:"+ suggestion) : ""),
        status: _status || status,
      }),
    }
    fetch(global.api + "v1/call-service/transaction/update", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status) {
          this.setState({loading: false, remark: ""})
          this.GET(uid);
          if(_status === "สำเร็จ"){
            let location_id = this.params("location_id");
            this.alert("success", "สำเร็จ", "ขอบคุณที่ใช้บริการ","","/service?location_id="+location_id)
          }else{
            this.alert("success", "สำเร็จ", "ส่งข้อความสำเร็จแล้ว เจ้าหน้าที่จะรีบดำเนินการให้ไวที่สุด")
          }
        } else {
          this.setState({loading: false, remark: ""})
          this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
        }
      }).catch(() => this.setState({loading: false}))
  }
  alert(icon, title, detail, html, url) {
  return Swal.fire({
    icon: icon === "submit" ? "info" : icon,
    title,
    text: detail,
    html,
    confirmButtonText: icon === "submit" ? "ยืนยัน" : "ตกลง",
    showCancelButton: icon === "submit",
    cancelButtonText: "ยกเลิก"
  }).then(result => {
    if (url) {
      window.location.href = url;
    }
    return result.isConfirmed;
  });
}
 params(key) {
  const value = new URLSearchParams(window.location.search).get(key);
  return value ? decodeURIComponent(value) : "";
}


  render() {
    const {step, status, remark, description,  running_number,
      project_name,
      agency_name,
      service_start_at, suggestion, star, showSecond} = this.state;
    return (
      <div className="full bg-contain">
        {this.state.loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div>
        <div>
        <div className="py-3 d-flex justify-content-center align-items-center">
          <img src={LOGO} alt="process" width={50} height={50} className="mb-1"/>
          <div>
            <h4 className="ml-2 mb-0 fw-bold">Haladiem</h4>
            <h6 className="ml-2 mb-0 fw-bold">Smart Service</h6>
          </div>
        </div>
        {step === 1 && (
        <div className="col-xl-10 col-lg-11 col-12 mx-auto">
          <div className="text-center mt-4">
            <h2 className="fw-bold">เลือกบริการที่ท่านต้องการ</h2>
            <h5 className="text-secondary mb-4">Select the service you need</h5>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6 px-2 mb-3 pointer">
              <div className="px-2 py-3 d-flex align-items-center shadow-lg rounded-1 card-hover" onClick={() => {
                this.Create("ต้องการรถรับส่ง","Parking Shuttle or Wheelchair");
              }}>
                <div className="rounded-circle d-flex align-items-center justify-content-center bg-white" style={{minWidth: 90, width: 90,height: 90, border: "3px solid #2f5597"}}>
                  {/* <img src={GOLFCART} alt="golf-cart" width={65} height={65} className="rounded-circle"/> */}
                   {!showSecond ? (
                      <img src={PROCESS} alt="process" width={65} height={65} className="rounded-circle"/>
                    ) : (
                      <img src={GOLFCART} alt="golf-cart" width={55} height={55} />
                    )}
                </div>
                <div className="pl-2">
                  <h4 className="fw-bold">ต้องการรถรับส่ง</h4>
                  <span>Parking Shuttle</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 px-2 mb-3 pointer">
              <div className="px-2 py-3 d-flex align-items-center shadow-lg rounded-1 card-hover" onClick={() => {
                this.Create("ขอรถเข็นนั่ง รถเข็นของ","Double Parking");
              }}>
                 <div className="rounded-circle d-flex align-items-center justify-content-center bg-white" style={{minWidth: 90, width: 90,height: 90, border: "3px solid #2f5597"}}>
                  {!showSecond ? (
                    <img src={TROLLEY} alt="trolley" width={65} height={65} className="rounded-circle"/>
                  ) : (
                    <img src={WHEELCHAIR} alt="wheelchair" width={55} height={55} />
                  )}
                </div>
                <div className="pl-2">
                  <h4 className="fw-bold">ขอรถเข็นนั่ง รถเข็นของ</h4>
                  <span>Double Parking</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 px-2 mb-3 pointer">
              <div className="px-2 py-3 d-flex align-items-center shadow-lg rounded-1 card-hover" onClick={() => {
                this.Create("รถจอดกีดขวาง / รถสตาร์ทไม่ติด ต้องการความช่วยเหลือ","The car's not starting");
              }}>
                 <div className="rounded-circle d-flex align-items-center justify-content-center bg-white" style={{minWidth: 90, width: 90,height: 90, border: "3px solid #2f5597"}}>
                  <img src={FIX} alt="process" width={55} height={55} style={{}}/>
                </div>
                <div className="pl-2">
                  <h4 className="fw-bold">รถจอดกีดขวาง <br className="d-block d-sm-none"/>รถสตาร์ทไม่ติด <br className="d-block d-md-none d-lg-none d-xl-block"/>ต้องการความช่วยเหลือ</h4>
                  <span>The car's not starting</span>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 px-2 mb-3 pointer">
              <div className="px-2 py-3 d-flex align-items-center shadow-lg rounded-1 card-hover" onClick={() => {
                this.Create("ขอความช่วยเหลือเร่งด่วน","Emergency");
              }}>
                 <div className="rounded-circle d-flex align-items-center justify-content-center bg-white" style={{minWidth: 90, width: 90,height: 90, border: "3px solid #2f5597"}}>
                  <img src={EMERGENCY} alt="process" width={55} height={55} style={{}}/>
                </div>
                <div className="pl-2">
                  <h4 className="fw-bold">ขอความช่วยเหลือเร่งด่วน</h4>
                  <span>Emergency</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
        {step === 2 && status && (
          <div className="col-xxl-7 col-xl-7 col-lg-8 col-md-9 col-12 mx-auto">
            {status === "ยกเลิก" ? (<div className="text-center">
              <div className="px-3 py-4 shadow-lg rounded-1 bg-white">
                <img src={CANCEL} alt="process" width={200} height={200}/>
              <h2 className="fw-bold">คำขอนี้ถูกยกเลิกแล้ว</h2>
              <h5 className="text-secondary mb-4">This request has been cancelled.</h5>
            <hr/>
            <h6 className="mb-1 text-center">Request ID</h6>
            <h2 className="mb-3 fw-bold text-center">{running_number.split("-")[1].slice(-4) || ""}</h2>
            <div className="text-secondary w-75 mx-auto mb-3">หากต้องการทำรายการใหม่ สามารถสแกน QRCode ในจุดที่ต้องการความช่วยเหลือ หรือคลิกที่ปุ่มด้านล่างนี้เพื่อขอความช่วยเหลือ ณ จุดเดิม</div>
            <button className="btn btn-primary px-4" onClick={() => {
              window.location.href = `/service?location_id=${this.params("location_id")}&project=${project_name}&agency=${agency_name}`
            }}>ส่งคำขอใหม่อีกครั้ง</button>
            </div>
            </div>): 
            status === "สำเร็จ" ? (<div className="text-center">
              <div className="px-3 py-4 shadow-lg rounded-1 bg-white">
                <img src={SUCCESS} alt="process" width={200} height={200}/>
              <h2 className="fw-bold">สำเร็จ</h2>
              <h5 className="text-secondary mb-4">This request has been successfully.</h5>
            <hr/>
            <h6 className="mb-1 text-center">Request ID</h6>
            <h2 className="mb-3 fw-bold text-center">{running_number.split("-")[1].slice(-4) || ""}</h2>
            {/* {!description.includes("rate:") && (
            <div>
            <div className="text-secondary w-75 mx-auto mb-3">โปรดให้คะแนนการบริการของเรา</div>
            <div className="d-flex justify-content-center mb-3">
              <div className="mx-1">{star >= 1 ? (<img src={STAR} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 1})}} />) : (<img src={STAR_} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 1})}} />)}</div>
              <div className="mx-1">{star >= 2 ? (<img src={STAR} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 2})}} />) : (<img src={STAR_} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 2})}} />)}</div>
              <div className="mx-1">{star >= 3 ? (<img src={STAR} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 3})}} />) : (<img src={STAR_} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 3})}} />)}</div>
              <div className="mx-1">{star >= 4 ? (<img src={STAR} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 4})}} />) : (<img src={STAR_} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 4})}} />)}</div>
              <div className="mx-1">{star >= 5 ? (<img src={STAR} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 5})}} />) : (<img src={STAR_} alt="process" width={100} height={100} onClick={()=>{this.setState({star: 5})}} />)}</div>
            </div>
             <input type="text" className="form-control mb-3" placeholder="ข้อเสนอแนะ" onChange={e=>this.setState({suggestion: e.target.value})} value={suggestion}/>
            <div className="d-flex justify-content-end">
              <button className="btn btn-primary px-4" onClick={() => {this.Update("สำเร็จ")}}>ยืนยัน</button>
            </div>
            </div>
            )} */}
            </div>
            </div>): 
            (<div>
            <div className="text-center mt-4">
              <h1 className="fw-bold">{this.params("service")}</h1>
              <h5 className="text-secondary mb-4">{this.params("service_en")}</h5>
            </div>
                <div className="px-3 py-4 shadow-lg rounded-1 bg-white">
                  <div className="w-100 d-flex justify-content-center text-center">
                    <img src={IMAGE_STATUS[status]} alt="process" width={200} height={200} className="d-block d-sm-none"/>
                  </div>
                  <div className="d-flex">
                    <img src={IMAGE_STATUS[status]} alt="process" width={200} height={200} className="mr-3 d-none d-sm-block"/>
                    <div className="w-100">
                      <h6 className="mb-1 text-center">Request ID</h6>
                      <h2 className="mb-3 fw-bold text-center">{running_number.split("-")[1].slice(-4) || ""}</h2>
                      <hr/>
                      <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 100}}>โครงการ: </div> {project_name}</h6>
                      <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 100}}>หน่วยงาน: </div> {agency_name}</h6>
                      <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 100}}>เวลาที่แจ้ง: </div> {format_date(service_start_at, "dd/mm/yyyy hh:mm:ss")}</h6>
                      <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 100}}>สถานะ: </div> {status}</h6>
                    </div>
                  </div>
                  <h6 className="d-flex mb-3 fw-bold">ติดต่อเจ้าหน้าที่</h6>
                  <div className="bg-light rounded-1 p-3 mb-3">
                  {description?.split("|")?.filter(e=>e).map(e=> {
                      if(e.startsWith("admin")){
                        return (
                        <div className="d-flex justify-content-start mb-1">
                          <div className="rounded-1 shadow py-2 px-3" style={{maxWidth: "75%", backgroundColor: "#ffffff"}}>{e.split(":")[1]}</div>
                        </div>
                        )
                      }else{
                        return (
                        <div className="d-flex justify-content-end mb-1">
                          <div className="rounded-1 shadow py-2 px-3 text-light" style={{maxWidth: "75%", backgroundColor: "#4c3bf9"}}>{e.split(":")[1]}</div>
                        </div>
                        )
                      }
                    }
                  )}
                  </div>
                  <input type="text" className="form-control mb-3" placeholder="ส่งข้อความ" onChange={e=>this.setState({remark: e.target.value})} value={remark}/>
                    <div className="d-flex justify-content-between">
                      <button className="btn btn-link text-danger px-4" onClick={async () => {
                         if(await this.alert("submit","ยกเลิก",`ยกเลิกคำขอนี้ใช่หรือไม่?`)){
                          this.Update("ยกเลิก")
                         }
                        }}>ยกเลิกคำขอ</button>
                      <button className="btn btn-primary px-4" onClick={() => {this.Update()}}>ส่งข้อความ</button>
                    </div>
            </div>
            </div>
          )}
          </div>
        )}
        </div>
      
            </div>
      </div>
    )
  }
}
